export default __webpack_public_path__ + "static/media/flag-deu.98528dce.svg";